/** V1 packing lots list and delabel strings (English), spread into en.ts. Hindi: v1-pack.hi.ts. */
export const v1PackEn = {
  // Packed lots (V1 port of pack/lots)
  'pack.v1.lots.list.title': 'Packed lots',
  'pack.v1.lots.list.see': 'See all packed lots',
  'pack.v1.heldRuns.title': 'Held runs to check',
  'pack.v1.heldRuns.line': '{count} {count:run is|runs are} held: check and close',
  'pack.v1.lots.list.seeLine': 'Waiting, OK to send or stopped',
  'pack.v1.hallTile.title': 'Packing hall',
  'pack.v1.hallTile.line': 'Pouches at the hall, send out',
  'pack.v1.lots.list.none': 'No packed lots at this hall yet',
  'pack.v1.lots.list.ready': '{n} {n:lot is|lots are} OK to send: pouches still at the hall',
  'pack.v1.lots.list.state.PACKING': 'Packing',
  'pack.v1.lots.list.state.WAITING': 'Waiting for OK',
  'pack.v1.lots.list.state.RELEASED': 'OK to send',
  'pack.v1.lots.list.state.HELD': 'Stopped',
  'pack.v1.lots.list.state.RECALLED': 'Called back',
  'pack.v1.lots.list.state.WITHDRAWN': 'Off sale',
  'pack.v1.lots.list.dates': 'Packed {pkd} · use before {bb}',
  'pack.v1.lots.list.cartons': '{full} {full:carton|cartons} of {per} + {partial}',
  'pack.v1.lots.list.waitingHint':
    'Keep the pouches in the waiting area. They go only after the office gives the OK.',
  'pack.v1.lots.list.heldHint': 'Stopped: put the **stopped** board on its cartons. Do not send.',
  'pack.v1.lots.list.recalledHint':
    'Called back: **do not move, do not sell**. The office is phoning the buyers.',
  'pack.v1.lots.list.reason': 'Why: {reason}',
  'pack.v1.lots.list.reason.LAB_FAIL': 'lab result failed',
  'pack.v1.lots.list.reason.RUN_MIXED': 'another batch got mixed in',
  'pack.v1.lots.list.reason.LABEL_MISMATCH': 'label check pending',
  'pack.v1.lots.list.reason.QUALITY': 'quality check',
  // Empty held pouches (V1 port of pack/delabel)
  'pack.v1.delabel.title': 'Empty stopped pouches',
  'pack.v1.delabel.row': 'Empty pouches · lot …{tail}',
  'pack.v1.delabel.rowLine': '{count} {count:pouch|pouches} · into new red-tie sacks',
  'pack.v1.delabel.missing': 'This emptying is not on this phone',
  'pack.v1.delabel.missingLine': 'Go back and check again with network.',
  'pack.v1.delabel.toEmpty': 'Pouches to empty or destroy',
  'pack.v1.delabel.rule':
    'Our label is **never used again**. Count the film and destroy it. Every new sack gets a **red tie**.',
  'pack.v1.delabel.job1': 'New sacks',
  'pack.v1.delabel.job1Line': 'Tag and weigh each sack',
  'pack.v1.delabel.job1Done': '{count} {count:sack|sacks} · {kg} kg',
  'pack.v1.delabel.job2': 'Count',
  'pack.v1.delabel.job2Line': 'Emptied, destroyed, film',
  'pack.v1.delabel.job2Done': '{emptied} emptied · {destroyed} destroyed · {film} film',
  'pack.v1.delabel.tag.title': 'Tag the new sack',
  'pack.v1.delabel.tag.hint': 'Scan the tag on the new red-tie sack',
  'pack.v1.delabel.tag.done': 'Sacks done',
  'pack.v1.delabel.tag.wait': 'Scan the new sack’s tag',
  'pack.v1.delabel.weigh.title': 'Weigh the sack',
  'pack.v1.delabel.weigh.label': 'Sack {n} on the scale',
  'pack.v1.delabel.weigh.sackType': 'Which sack?',
  'pack.v1.delabel.weigh.save': 'Save sack',
  'pack.v1.delabel.weigh.wait': 'Type the scale reading',
  'pack.v1.delabel.saved': 'Sack {n} saved · {kg} kg',
  'pack.v1.delabel.count.title': 'Count the pouches',
  'pack.v1.delabel.count.emptied': 'Pouches emptied',
  'pack.v1.delabel.count.destroyed': 'Destroyed whole',
  'pack.v1.delabel.count.film': 'Film destroyed',
  'pack.v1.delabel.count.filmHint': 'One film for each emptied pouch',
  'pack.v1.delabel.count.gap': '{n} of {m} pouches counted',
  'pack.v1.delabel.count.filmShort': 'Film is less than the pouches emptied',
  'pack.v1.delabel.count.done': 'Counts done',
  'pack.v1.delabel.count.wait': 'Type all three counts',
  'pack.v1.delabel.wait.sacks': 'Weigh the new sacks first',
  'pack.v1.delabel.wait.count': 'Count the pouches',
  'pack.v1.delabel.close.cta': 'Close emptying',
  'pack.v1.delabel.close.title': 'Close emptying?',
  'pack.v1.delabel.close.yes': 'Yes, close',
  'pack.v1.delabel.close.sacks': '{count} · {kg} kg',
  'pack.v1.delabel.close.locked': 'After closing, the counts **cannot change**.',
  'pack.v1.delabel.done.title': 'Closed',
  'pack.v1.delabel.done.line': 'Lot …{tail} · {count} {count:pouch|pouches}',
  'pack.v1.delabel.done.s1': 'The office records the disposal.',
  'pack.v1.delabel.closed': 'This emptying is closed',
}

export type V1PackMessageKey = keyof typeof v1PackEn
